import PropTypes from 'prop-types'

import { RdtChangeMode } from '../../models/rdt/rdt-change-mode-enum'
import { iso8601DurationPropType } from '../common/iso-8601-duration-prop-type'
import { iso8601PropType } from '../common/iso-8601-prop-type'

/**
 * @typedef {Object} DurationRest
 * @property {ISO8601Duration} [duration] - The duration of time
 * @property {ISO8601} [referenceTime]    - The reference time on the server
 * @property {string} [changeMode]        - The mode how this value is changing
 */
export const durationRestPropType = PropTypes.shape({
    changeMode: PropTypes.oneOf(Object.values(RdtChangeMode)),
    duration: iso8601DurationPropType,
    referenceTime: iso8601PropType
})
